import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Hero from '../components/careers/Hero';
import CareerSlide from '../components/careers/CareerSlide';
import { useTranslation } from 'react-i18next';

const Careers: React.FC = () => {
  const { t } = useTranslation();

  // Career image arrays for each left/right position
  const salesLeftImages = ['/images/Careers/4.1.jpg', '/images/Careers/4.3.jpg'];
  const salesRightImages = ['/images/Careers/4.0.jpg', '/images/Careers/4.2.jpg'];

  const hrLeftImages = ['/images/Careers/5.png', '/images/Careers/5.2.jpg'];
  const hrRightImages = ['/images/Careers/5.1.png', '/images/Careers/5.3.jpg'];

  const importLeftImages = ['/images/Careers/2.jpg', '/images/Careers/2.2.jpg'];
  const importRightImages = ['/images/Careers/2.0.jpg', '/images/Careers/2.3.jpg'];

  const exportLeftImages = ['/images/Careers/3.0.jpg', '/images/Careers/3.3.jpg'];
  const exportRightImages = ['/images/Careers/3.1.jpg', '/images/Careers/3.2.jpg'];

  const agricultureLeftImages = ['/images/Careers/6.jpg', '/images/Careers/6.3.jpg'];
  const agricultureRightImages = ['/images/Careers/6.1.jpg', '/images/Careers/6.2.jpg'];

  const accountantLeftImages = ['/images/Careers/7.0.jpg', '/images/Careers/7.2.jpg'];
  const accountantRightImages = ['/images/Careers/7.3.jpg', '/images/Careers/7.3.jpg'];

  return (
    <>
      <Hero />
      <div className="careers-page margin-top-75" style={{ background: '#fff' }}>
        <Container>
          {/* Top Section */}
          <Row className="mb-5 careers-top-section">
            <Col md={6} className="mb-4 mb-md-0 ps-0">
              <div className="careers-main-img position-relative card-hover-animation">
                <img
                  src="/images/Careers/1.jpg"
                  alt={t('career.topSection.experts')}
                  className="w-100 h-100 object-fit-cover rounded expert-img image-hover-animation"
                  style={{ minHeight:300, height: 430, objectFit: 'cover' }}
                />
                {/* <div 
                  className="careers-img-gradient position-absolute rounded"
                  style={{ left: 0, bottom: 0, width: '100%', height: '100%', zIndex: 1, background: 'linear-gradient(90deg, rgba(0, 0, 0, 0) 70%, rgba(198, 164, 95, 0.43) 100%)', pointerEvents: 'none' }}
                ></div> */}
                <div className="careers-img-overlay position-absolute" style={{ left: 0, bottom: 0, color: '#fff', padding: '1rem 1.5rem', zIndex: 2 }}>
                  <div className='menu-item'>{t('career.topSection.experts')}</div>
                  <div style={{ fontWeight: 700, fontSize: 20, color: '#D7AB50', background:'#fff', padding:'0px 35px 0px 15px' }}>R . L. CO., LTD</div>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="careers-main-desc">
                <div className='d-flex align-items-center'>
                  <span className="blog-header-bar me-3"></span>
                  <div className='header-2 color-brown py-0'>{t('career.topSection.title')}</div>
                </div>
                <div className='body-text text-justify mb-4'>
                  <span className='menu-item'>{t('about.history.header')} </span> {t('career.topSection.description')}
                </div>
                <div className='body-text text-justify'>
                  {t('career.topSection.teamDescription')}
                </div>
              </div>
            </Col>
          </Row>

          {/* Our Jobs Section */}
          <div className="careers-jobs-section mb-5">
            <div className='d-flex align-items-center'>
              <span className="job-header-bar me-3"></span>
              <div className='header-2 color-brown py-0'>{t('career.jobs.title')}</div>
            </div>
            <div className='menu-item color-light mb-5' style={{ background: '#C6A45F', padding: '0px 35px 0px 15px', display: 'inline-block' }}>
              {t('career.jobs.subtitle')}
            </div>
            <div className="service-cards-col d-flex flex-column gap-5 w-100 service-main">
              <div className="d-flex gap-3 service-card-container">
                <div className="service-bar"></div>
                <div className="service-box flex-fill">
                  <div className="service-img-half left">
                    <CareerSlide 
                      images={salesLeftImages}
                      alt={t('career.jobs.positions.sales')}
                    />
                    <div className="service-label menu-item">{t('career.jobs.positions.sales')}</div>
                  </div>
                  <div className="service-img-half right">
                    <CareerSlide 
                      images={salesRightImages}
                      alt={t('career.jobs.positions.sales')}
                    />
                  </div>
                </div>
                <div className="service-bar ms-2"></div>
                <div className="service-box flex-fill">
                  <div className="service-img-half left">
                    <CareerSlide 
                      images={hrLeftImages}
                      alt={t('career.jobs.positions.hr')}
                    />
                    <div className="service-label menu-item">{t('career.jobs.positions.hr')}</div>
                  </div>
                  <div className="service-img-half right">
                    <CareerSlide 
                      images={hrRightImages}
                      alt={t('career.jobs.positions.hr')}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex gap-3 service-card-container">
                <div className="service-bar"></div>
                <div className="service-box flex-fill">
                  <div className="service-img-half left">
                    <CareerSlide 
                      images={importLeftImages}
                      alt={t('career.jobs.positions.import')}
                    />
                    <div className="service-label menu-item">{t('career.jobs.positions.import')}</div>
                  </div>
                  <div className="service-img-half right">
                    <CareerSlide 
                      images={importRightImages}
                      alt={t('career.jobs.positions.import')}
                    />
                  </div>
                </div>
                <div className="service-bar ms-2"></div>
                <div className="service-box flex-fill">
                  <div className="service-img-half left">
                    <CareerSlide 
                      images={exportLeftImages}
                      alt={t('career.jobs.positions.export')}
                    />
                    <div className="service-label menu-item">{t('career.jobs.positions.export')}</div>
                  </div>
                  <div className="service-img-half right">
                    <CareerSlide 
                      images={exportRightImages}
                      alt={t('career.jobs.positions.export')}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex gap-3 service-card-container">
                <div className="service-bar"></div>
                <div className="service-box flex-fill">
                  <div className="service-img-half left">
                    <CareerSlide 
                      images={agricultureLeftImages}
                      alt={t('career.jobs.positions.agriculture')}
                    />
                    <div className="service-label menu-item">{t('career.jobs.positions.agriculture')}</div>
                  </div>
                  <div className="service-img-half right">
                    <CareerSlide 
                      images={agricultureRightImages}
                      alt={t('career.jobs.positions.agriculture')}
                    />
                  </div>
                </div>
                <div className="service-bar ms-2"></div>
                <div className="service-box flex-fill">
                  <div className="service-img-half left">
                    <CareerSlide 
                      images={accountantLeftImages}
                      alt={t('career.jobs.positions.accountant')}
                    />
                    <div className="service-label menu-item">{t('career.jobs.positions.accountant')}</div>
                  </div>
                  <div className="service-img-half right">
                    <CareerSlide 
                      images={accountantRightImages}
                      alt={t('career.jobs.positions.accountant')}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* HR Contact Section */}
          <Row className="d-flex align-items-start justify-content-start hr-section card-hover-animation" style={{ background: '#D7AB50', borderRadius: 2, padding: '15px 5px', marginBottom: 32 }}>
            <Col md={4} className="mb-3 mb-md-0 w-50">
              <img src="/images/Careers/8.jpg" alt="HR" className="w-100 object-fit-cover hr-img image-hover-animation" style={{ minHeight: 200, height: 290, objectFit: 'cover', borderRadius: 4 }} />
            </Col>
            <Col md={8} className="w-50">
              <div style={{ color: '#fff' }}>
                <div className='d-flex align-items-center'>
                  <span className="hr-header-bar me-3"></span>
                  <div className='header-2 color-light py-0'>{t('career.contact.title')}</div>
                </div>
                <div className='menu-item color-light mb-5'>{t('career.contact.subtitle')}</div>
                <div style={{ fontWeight: 700, fontSize: 24, marginBottom: 4, marginTop: 12 }}>{t('career.contact.name')}</div>
                <div className='body-text color-light'>{t('career.contact.email')} <a href="mailto:admin@rltransports.biz" style={{ color: '#fff', textDecoration: 'underline' }}> admin@rltransports.biz</a></div>
                <div className='body-text color-light'>{t('career.contact.mobile')} +855 11 559 569</div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Careers; 